import ContentContainer from "@client/content/container";
import ErrorBoundary from "@client/controls/ErrorBoundary/component";
import { type EntityRef } from "@client/types";
import * as React from "react";
import Component from "./Component/container";
import Container from "./Container/container";
import TextComponent from "./TextComponent/component";

export type ViewerLayoutEntityComponentProps = EntityRef & {
  gid: string | null | undefined;
  isModule: boolean;
  style?: React.CSSProperties;
  viewonly?: boolean;
};

export default ({ gid, ...props }: ViewerLayoutEntityComponentProps) => {
  if (gid) return <Component gid={gid} id={props.id} />;

  if (props.isModule) {
    return (
      <ErrorBoundary hideError>
        <ContentContainer
          id={props.id}
          source={props.source}
          TextComponent={TextComponent}
          StaticContainer={ContentContainer}
          viewonly={props.viewonly}
        />
      </ErrorBoundary>
    );
  }

  return <Container id={props.id} viewonly={props.viewonly} source={props.source} style={props.style} />;
};
